export function openGIP(to: string) {
  const env = process.env.REACT_APP_LINK_GIP;
  if (!env) {
    throw new Error('REACT_APP_LINK_GIP is not setup.');
  }
  window.location.href = `${env}${to}`;
}